import { Link } from "react-router-dom";
import Header from "../../Landing/Header/Header";
import icon01 from "../../../screenassets/images/about/01.png";
import iconStar from "../../../screenassets/images/banner/star.svg";
import icon02 from "../../../screenassets/images/about/02.png";
import icon_team01 from "../../../screenassets/images/team/01.jpg";
import icon_team02 from "../../../screenassets/images/team/02.jpg";
import icon_team03 from "../../../screenassets/images/team/03.jpg";
import icon_team04 from "../../../screenassets/images/team/04.jpg";
import icon_team05 from "../../../screenassets/images/team/05.jpg";
import icon_team06 from "../../../screenassets/images/team/06.jpg";
import icon_team07 from "../../../screenassets/images/team/07.jpg";
import icon_team08 from "../../../screenassets/images/team/08.jpg";
import icon03 from "../../../screenassets/images/img/01.png";
import { FaFacebookF } from "react-icons/fa";
import { TfiTwitterAlt } from "react-icons/tfi";
import { SiInstagram } from "react-icons/si";
import { IoLogoWhatsapp } from "react-icons/io";
import { IoMdStar } from "react-icons/io";
import { IoIosStarHalf } from "react-icons/io";
import icon04 from "../../../screenassets/images/cta/02.png";
import Footer from "../Footer/Footer"
import Icons from "./Icons";


export default function About() {
  return (
    <>
      {/* Header Section */}
      <Header />

      {/* Bread-crumb Section */}
      <div className="rts-bread-crumb-area bg_image">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="breadcrumb-inne">
                <div className="title-area">
                  <h1 className="bread-title">About </h1>
                  <div className="inner-wrapper">
                    <Link to="/">Home</Link>/
                    <Link to="#" className="active">About</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* About section  */}
      <div className="about-section-one inner-about rts-section-gap">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="left-thumbnail-area">
                <img src={icon01} alt="thumbanil" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-p-right">
                <div className="title-left-area">
                  <span className="pre-title-bg">About Us</span>
                  <h2 className="title">
                    Empowering Students with <br />
                    Verified, Step-by-Step <br />
                    Board Exam Solutions
                  </h2>
                </div>
                <div className="inner-content">
                  <p className="disc-l">
                    We’re building India’s most trusted digital learning companion — helping students from Classes 6–12 across all india's boards like WBBSE, WBCHSE, BSE Odisha, CHSE, CBSE, ICSE, UP, Bihar, Maharashtra etc. Our mission is simple: make every student understand how to solve, not just what the answer is.
                  </p>
                  <div className="rating-area">
                    <div className="rating">
                      <img src={iconStar} alt="start" />
                      <img src={iconStar} alt="start" />
                      <img src={iconStar} alt="start" />
                      <img src={iconStar} alt="start" />
                      <img src={iconStar} alt="start" />
                    </div>
                    <p className="disc">Based on 10,000+ reviews on</p>
                  </div>

                  {/* <div className="brand-arae">
                    <img src={brand01} alt="brand" />
                    <img src={brand02} alt="brand" />
                    <img src={brand03} alt="brand" />
                    <img src={brand04} alt="brand" />
                  </div> */}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      {/* Favourite Tools Section */}
      <div className="favourite-tools-area rts-section-gapBottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-conter-area">
                <span className="pre-title-bg">Features</span>
                <h2 className="title">
                  Built for Smarter <br />
                  Confident Learning
                </h2>
              </div>
            </div>
          </div>
          <div className="row mt--10 g-5">
            <div className="col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="single-case-area-wrapper">
                <div className="">
                  <Icons image={require("../../../screenassets/images/img/homework.png")} />
                </div>
                <Link to="/">
                  <h5 className="title">Homework Solver</h5>
                </Link>
                <p className="disc">
                  Upload a photo and get verified step-by-step solutions for math, science, and more.
                </p>
                <Link to="/signin">Try Now <i className="fa-solid fa-arrow-right"></i></Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="single-case-area-wrapper">
                <div className="">
                  <Icons image={require("../../../screenassets/images/img/contract.png")} />
                </div>
                <Link to="/">
                  <h5 className="title">Past Paper Practice</h5>
                </Link>
                <p className="disc">
                  Access board-wise questions with model answers and revision notes.
                </p>
                <Link to="/signin">Try Now <i className="fa-solid fa-arrow-right"></i></Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="single-case-area-wrapper">
                <div className="">
                  <Icons image={require("../../../screenassets/images/img/help.png")} />
                </div>
                <Link to="/">
                  <h5 className="title">Instant Help</h5>
                </Link>
                <p className="disc">
                  No waiting — get your answers explained instantly for better understanding.
                </p>
                <Link to="/signin">Try Now <i className="fa-solid fa-arrow-right"></i></Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Image arae Section */}
      <div className="rts-large-image-area rts-section-gapBottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="large-image-about-p">
                <img src={icon02} alt="about-image" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      <div className="rts-testimonials-area rts-section-gapBottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-conter-area">
                <span className="pre-title-bg">Features</span>
                <h2 className="title">
                  Trusted by 10,000+ Students <br />
                   Across India
                  <span className="gradient-about-title">5-star ratings.</span>
                </h2>
                <div className="rating-area-main-p">
                  <div className="rating-area">
                    <div className="rating">
                      <img src={iconStar} alt="start" />
                      <img src={iconStar} alt="start" />
                      <img src={iconStar} alt="start" />
                      <img src={iconStar} alt="start" />
                      <img src={iconStar} alt="start" />
                    </div>
                    <p className="disc">Based on 10,000+ reviews on</p>
                  </div>
                  <p className="disc-5">From board toppers to daily learners, students rely on our verified, step-by-step solutions to prepare smarter and score higher.</p>

                </div>
              </div>
            </div>
          </div>
          <div className="row g-5 mt--30">

            <div className="col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="single-team-area">
                <img src="assets/images/team/brand/quote.png" alt="" className="quote" />
                <div className="star">
                  <IoMdStar />
                  <IoMdStar />
                  <IoMdStar />
                  <IoMdStar />
                  <IoIosStarHalf />
                </div>
                <p className="disc">
                  “I finally understand how to solve my CBSE Physics numericals step-by-step. The Bengali medium support helped me a lot!”
                </p>
                <div className="authore-area">
                  <div className="author">
                    <img src={icon03} alt="team" />
                    <div className="info">
                      <p>Sampurna</p>
                      <span>Class 12 (CBSE)</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="single-team-area">
                <img src="assets/images/team/brand/quote.png" alt="" className="quote" />
                <div className="star">
                  <IoMdStar />
                  <IoMdStar />
                  <IoMdStar />
                  <IoMdStar />
                  <IoIosStarHalf />
                </div>
                <p className="disc">
                  “The Odia medium answers are so clear and easy to follow. Perfect for CHSE board students like me.”
                </p>
                <div className="authore-area">
                  <div className="author">
                    <img src={icon03} alt="team" />
                    <div className="info">
                      <p>Samrat</p>
                      <span>Class 10 (CHSE Odisha)</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="single-team-area">
                <img src="assets/images/team/brand/quote.png" alt="" className="quote" />
                <div className="star">
                  <IoMdStar />
                  <IoMdStar />
                  <IoMdStar />
                  <IoMdStar />
                  <IoIosStarHalf />
                </div>
                <p className="disc">
                   "I used to spend hours searching for correct solutions in Bengali for my WBBSE Class 10 math problems. With this platform, I just upload a question and get clear step-by-step answers instantly. It’s like having my teacher always on standby!"
                </p>
                <div className="authore-area">
                  <div className="author">
                    <img src={icon03} alt="team" />
                    <div className="info">
                      <p>Ankita Saha</p>
                      <span>Class 10 (WBBSE – Bengali Medium)</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="rts-cta-area rts-section-gapBottom bg_faq">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="cta-main-wrapper bg_image">
                <div className="left">
                  <h3 className="title">
                    Start Your Journey Toward Smarter <br />
                    Learning Today
                  </h3>
                  <Link to="/about" className="rts-btn btn-primary text-white" >Create Account</Link>
                </div>
                <div clclassNameass="right">
                  <img src={icon04} alt="cta-area" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Section */}
      <Footer />

    </>
  )
}
